import { render, staticRenderFns } from "./DmqCartIcon.vue?vue&type=template&id=617a3f4a&"
import script from "./DmqCartIcon.vue?vue&type=script&lang=ts&"
export * from "./DmqCartIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports